import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { NotificationService } from "../utils/notification.service";
import { BAD_REQUEST, DEFAULT_ERROR_TEXT, INTERNAL_SERVER_ERROR, NOT_FOUND } from "./error.handler";

export class ErrorInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skip = request.headers.has('x-skip-error-handler');

    return skip ? next.handle(request) : next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
      // NOTE: check if this block is actual
      if (error.error instanceof ErrorEvent) {
        console.error('Client side error detected.');
      } else {
        this.notificationService.showError(this.getErrorMessage(error));
      }
      return throwError(() => error);
    }));
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 500:
        return INTERNAL_SERVER_ERROR;
      case 400:
        return error?.error?.message ?? BAD_REQUEST;
      case 404:
        return error?.error?.message ?? NOT_FOUND;
      case 422:
        return error?.error?.message ?? DEFAULT_ERROR_TEXT;
      default:
        return DEFAULT_ERROR_TEXT;
    }
  }
}
